import utils from 'hey-utils';

const rclass = /[\t\r\n\f]/g;

export default utils.extend({}, utils, {
  getClass(elem) {
    return (elem.getAttribute && elem.getAttribute('class')) || '';
  },
  hasClass(elem, selector) {
    let className;
    className = ` ${selector} `;
    if (elem.nodeType === 1 && (` ${this.getClass(elem)} `)
      .replace(rclass, ' ')
      .indexOf(className) > -1) {
      return true;
    }

    return false;
  },
  getLocal(name, type) {
    if (!window.localStorage || !name) {
      return null;
    }
    const data = window.localStorage.getItem(name);
    if (data == null || data === 'null' || data === 'undefined' || data === '') {
      return null;
    }
    if (type && type == 'json') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    return data;
  },
  removeLocal(name) {
    if (window.localStorage && name) {
      window.localStorage.removeItem(name);
    }
    return null;
  }
});
